import React, { useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import useQuery from '../../utils/useQuery';
import { sendPermTokenRequest } from '../../utils/api/accountApi';
import { genericErrorMessage } from '../../utils/lang/commonErrors';
import { saveFromOrderAuthParams } from '../../utils/authInterceptor';

import SocialButton from './fields/SocialButton';

import styles from './EnterForm.scss';

const EnterForm = () => {
  const history = useHistory();
  const { permanent_access_token: permanentToken, err_message: error } = useQuery();

  const intl = useIntl();

  useEffect(() => {
    saveFromOrderAuthParams();

    if (error === 'ErrAccountTerminated') {
      window.location = '/enter/restore';
    }

    if (permanentToken) {
      sendPermTokenRequest(permanentToken).then(() => history.push('/profile'));
    }
  }, []);

  return (
    <div className={styles.form}>
      <h2 className={styles.title}>
        <FormattedMessage
          id="enter.title"
          defaultMessage="Choose your way to sign up"
          description="Title of the enter page"
        />
      </h2>

      <p className={`${styles.subtitle} ${error ? styles.subtitleWithError : ''}`}>
        <FormattedMessage
          id="enter.subtitle"
          defaultMessage="If you already have a ClearVPN account, please,<link>Log In</link>"
          description="Subtitle of the enter page, offering user to log in if they have an account already"
          values={{
            link: (chunk) => <Link to="/enter/login">{chunk}</Link>,
          }}
        />
      </p>

      {error && (
        <span className={styles.errorInfo}>
          {error === 'ErrDevicesPerAccountLimitExceeded'
            ? intl.formatMessage({
                id: 'enter.error.deviceLimitExceeded',
                defaultMessage: 'Devices limit exceeded, please log in to manage your devices',
                description:
                  'Error message show to user with exceeded maximum number of devices; ' +
                  'user should log in to remove unneeded devices from their profile page.',
              })
            : error === 'ErrAccountAlreadyExists'
            ? intl.formatMessage(
                {
                  id: 'enter.error.accountAlreadyExists',
                  defaultMessage:
                    'This account already exists.{br}Try using another email or <supportLink>contact support</supportLink> to transfer your Premium plan to your old account.',
                  description:
                    'Error message shown, when user tries to sign up with an email, that`s already registered',
                },
                {
                  br: <br />,
                  supportLink: (chunk) => <a href="https://support.clearvpn.com/hc/?open_chat=1">{chunk}</a>,
                },
              )
            : intl.formatMessage(genericErrorMessage)}
        </span>
      )}

      <SocialButton title="Google" />
      <SocialButton title="Facebook" />
      <SocialButton title="Apple" />
      <SocialButton title="Setapp" />

      <Link to="/enter/email" className={styles.toSignUp}>
        <FormattedMessage
          id="enter.signUpWithEmail"
          defaultMessage="Create Account with Email"
          description="Link to regular sign up page with email & password fields"
        />
      </Link>
    </div>
  );
};

export default EnterForm;
